import { memo } from 'react';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';

import formStyles from './../../../../assets/styles/componentStyles/manychatStyles/workflowFormComponents/workflowForm.module.scss'
import { ChatbotStepActionData, SaveVariableActionData } from '../../../../models/flowBuilderTypes';

type SaveVariableNodeData = ChatbotStepActionData<SaveVariableActionData | ChatbotStepActionData<SaveVariableActionData>[]>;

const hasAiExtraction = (data: SaveVariableNodeData): boolean => {
    const actionData = data.action_data;
    if (Array.isArray(actionData)) {
        return actionData.some((action) => action?.action_data?.flag_ai_extraction);
    }
    return Boolean(actionData?.flag_ai_extraction);
};

const renderAiExtractionIcon = (data: SaveVariableNodeData) =>
    hasAiExtraction(data) ? <AutoAwesomeIcon className={formStyles.dataSavedAiExtractionIcon} /> : null;

const SaveVariable = ({ id, data }: { id: string, data: SaveVariableNodeData }) => {
    return (
        <>
            {
                data.type ? //this is for variables taken by payload keys 
                    // Array.isArray(data?.action_data) ?
                    <>  
                        {(data as ChatbotStepActionData<ChatbotStepActionData<SaveVariableActionData>[]>).action_data?.find((action) => action?.action_data?.value_type === "user_flow_message_payload" || action?.action_data?.value_type === "user_message_payload") ? 
                            <div>
                                <span className={formStyles.dataSavedTextStyle}>
                                    {`Save Data`}
                                    {renderAiExtractionIcon(data)}
                                </span>
                                <span className={formStyles.dataSavedValueStyle}>
                                    {/* {(data as ChatbotStepActionData<ChatbotStepActionData<SaveVariableActionData>[]>).action_data?.[0]?.action_data?.} */}
                                    {"View configured payload of the output and flow output variables and webhook payload keys"}
                                </span>
                            </div>
                        :
                            <div>
                                <span className={formStyles.dataSavedTextStyle}>
                                    {`Data Saved in `}
                                    {renderAiExtractionIcon(data)}
                                </span>
                                <span className={formStyles.dataSavedValueStyle}>
                                    {(data as ChatbotStepActionData<ChatbotStepActionData<SaveVariableActionData>[]>).action_data.map((payloadKeyVar: any) => {
                                        return <><div>{payloadKeyVar.action_data.payload_key} : {payloadKeyVar.action_data?.chatbot_custom_variable_configuration?.chatbot_custom_variable_name},</div></>
                                    })}
                                </span>
                            </div>

                        }
                    </>
                    :
                    <>
                        <div>
                            <span className={formStyles.dataSavedTextStyle}>
                                {`Data Saved in `}
                                {renderAiExtractionIcon(data)}
                            </span>
                            <span className={formStyles.dataSavedValueStyle}>
                                {` ${(data as ChatbotStepActionData<SaveVariableActionData>).action_data?.chatbot_custom_variable_configuration?.chatbot_custom_variable_name ? 
                                    (data as ChatbotStepActionData<SaveVariableActionData>).action_data?.chatbot_custom_variable_configuration?.chatbot_custom_variable_name 
                                    : (data as ChatbotStepActionData<SaveVariableActionData>).action_data?.value_type === "user_flow_message_payload" ? 
                                        "Please configure flow output variables *" 
                                            : "Please Configure Variable *"}
                                `}    
                            </span>
                        </div>
                    </>
            }
        </>
    );
};

export default memo(SaveVariable);